import { render } from "./MainTabber.vue?vue&type=template&id=2336774e&scoped=true"
import script from "./MainTabber.vue?vue&type=script&lang=js"
export * from "./MainTabber.vue?vue&type=script&lang=js"

import "./MainTabber.vue?vue&type=style&index=0&id=2336774e&scoped=true&lang=scss"

import exportComponent from "D:\\建龙工作\\开发项目\\VUE程序包\\宿舍报修系统\\bxxt\\bxxt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2336774e"]])

export default __exports__